import React from 'react';
import { GraphQLClient } from 'graphql-request';

export type ContextProps = {
  client: GraphQLClient;
};

const GraphQLRequestContext = React.createContext<Partial<ContextProps>>({});

export default GraphQLRequestContext;
